export default "__VITE_ASSET__SDMYrQkw__"